import { IRegion } from '../../../types/geoSwitcher';
import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetGeoSuggestSucceed, EGetGeoSuggestActionTypes } from './types';

export const getSuggestionsSucceed: (suggests: IRegion[]) => TGetGeoSuggestSucceed = actionGenerator<
  EGetGeoSuggestActionTypes.Succeed,
  IRegion[]
>(EGetGeoSuggestActionTypes.Succeed);
